import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: {},
});

const { Types, Creators } = createActions({
  getItemOptions: ['storeId'],
  getItemOptionsConnected: ['storeId', 'itemOptions'],
  getItemOptionsError: ['error'],
  getItemOptionsDisconnected: null,
});

export const getItemOptionsReducer = (state) =>
  state.set('loading', true)

export const getItemOptionsConnectedReducer = (state, { itemOptions, storeId }) =>
  state.setIn(['data', storeId], itemOptions)
    .set('loading', false)

export const getItemOptionsDisconnectedReducer = (state) =>
  state.set('loading', false)

export const getItemOptionsErrorReducer = (state, { error }) =>
  state.set('error', error)
    .set('loading', false)

export const itemOptionReducer = createReducer(INITIAL_STATE, {
  [Types.GET_ITEM_OPTIONS]: getItemOptionsReducer,
  [Types.GET_ITEM_OPTIONS_CONNECTED]: getItemOptionsConnectedReducer,
  [Types.GET_ITEM_OPTIONS_DISCONNECTED]: getItemOptionsDisconnectedReducer,
  [Types.GET_ITEM_OPTIONS_ERROR]: getItemOptionsErrorReducer,
})


export const ItemOptionTypes = Types
export default Creators;


// WEBPACK FOOTER //
// ./src/reducers/itemOptionReducer.js